"use client";
import React from "react";
import { FooterBottom, FooterMain } from "./components";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { getFooterBackground } from "@/lib/backgrounds";


export default function FooterSection() {
  const pathname = usePathname();
  const bg = getFooterBackground(pathname);

  return (
    <footer className={`${bg} py-10  md:py-20 `}>
      <div className="scontainer space-y-10 w-full text-white">
        <FooterMain />
        <div
          className={cn(
            " w-full h-[2px]",
            pathname === "/"
              ? "bg-gradient-to-r from-[#170401] via-white to-[#170401]"
              : "bg-white/30"
          )}
        />
        <FooterBottom />
      </div>
    </footer>
  );
}
